import React from "react";
import {
  BookFreeSession,
  BookPhotoSession,
  BecomeaMember,
} from "../components/btn/SchedulePost";
import AppointmentForm from "../components/form/AppointmentForm";

const Appointment = () => {
  return(
    <div>
      <div className="m-10">
        <h3 className="delius-regular text-textPrimary font-bold text-[1.55rem]  text-center max-w-5xl mx-auto">
            Let's get you scheduled  📸
        </h3>
      </div>
       
      <div className="m-10 p-10 border border-primary rounded-xl">
        <stripe-pricing-table pricing-table-id="prctbl_1QkKJnKvS67ciXzmfxCuu51O"
        publishable-key="pk_live_51QkJJjKvS67ciXzmlXEutFltb0Xq4J7fjRh3pSnjizfflrOTmOi23eiZZyydMgusuCOjjlyDtq0WAH3vI6MzqqY900WAOxEpQC">
        </stripe-pricing-table>
      </div>
      
    </div>
    
  )
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  // return (
  //   <div>
  //     <div className="bg-neutralLight">
  //       <div className="container mx-auto py-12 md:py-16 flex flex-col space-y-4 items-center">
  //         <p className="text-textSecondary text-lg text-center max-w-2xl mx-auto font-light poppins">
  //           Lorem ipsum dolor sit amet consectetur
  //         </p>
  //         <h2 className="text-textSecondary md:font-satoshi font-bold leading-[3rem] text-[2.6rem] md:text-5xl lg:text-7xl text-center max-w-5xl mx-auto">
  //           Appointment scheduling
  //         </h2>
  //         <hr className="border border-boderLight opacity-55" />

  //         <p className="text-textNeutral md:text-lg text-center max-w-3xl mx-auto font-normal">
  //           Lorem ipsum dolor sit amet consectetur. Faucibus venenatis vitae
  //           nisi morbi netus. Vivamus rhoncus amet risus morbi feugiat id
  //           blandit aliquam sem
  //         </p>
  //         <div className="w-full"> 
  //           <BookFreeSession />
  //         </div>
  //         <div className="my-4"></div>
  //         <div className="w-full sm:w-max flex flex-col sm:flex-row items-center justify-center gap-4">
  //           <BookPhotoSession />
  //           <BecomeaMember />
  //         </div>
  //       </div>
  //     </div>

  //     <AppointmentForm />
  //   </div>
  // );
};

export default Appointment;
